<template>
  <v-autocomplete
    v-model="selectedRFC"
    :items="datosFiscales"
    item-text="Nombrereceptor"
    :item-value="item => item"
    label="Selecciona receptor"
    clearable
    hide-no-data
    @input="onSelect"
    @update:search-input="onSearch"
    outlined dense
  :rules="[v => $rules.ruleSelectIdGenericReq('RFC')(v)]"
  ></v-autocomplete>
</template>

<script>
export default {
  props: [], // se puede recibir props si quieres filtrar por tipo persona
  data() {
    return {
      selectedRFC: null,
      datosFiscales: [],
      searchNombre: '',
    };
  },
  methods: {
    onSearch(val) {
      this.searchNombre = val;
      if (val?.length >= 2) {
        this.fetchDatos(val);
      }
    },
    fetchDatos(nombre) {
      this.$http.get(`datosfiscales/busca-nombre`, { params: { search: nombre } })
        .then(response => {
          if (response.status === 200) {
            this.datosFiscales = response.data;
          }
        })
        .finally(() => {
        });
    },
    onSelect(item) {
      // Aquí podrías emitir un evento al padre si quieres
      this.$emit('select', item);
    }
  }
};
</script>
